import { Injectable } from '@angular/core';
import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import * as Enum from '../utils/enums';
import { Observable } from "rxjs";
import { RequestBuilder } from '../classes/request-builder';

@Injectable()
export class FilieraService extends BaseService {

    /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
    constructor(http: Http) {
        super(http)
    }

    /**
     * Get Filiera data
     * @param reqBuilder
     */
    getFilieraData(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
          payload = reqBuilder
        }
        return this.doPost('filiera/fetch', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
      }

}
